export class CertificacionPais {

    constructor(config = {}) {
        this.model = {
            id: {
                value: null,
                header: 'Código',
            },
            pais: {
                value: null,
                header: 'País:',
                table: true,
                required: 'Seleccione alguna opción'
            },
            identificacion_contribuyente: {
                value: '',
                table: true,
                header: 'Número de identificación del contribuyente:',
                maxLength: 'Máximo 50 caracteres',
                minLength: 'Mínimo 4 caracteres',
                max: 50,
                min: 4,
                required: 'Campo requerido'
            },
        }
    }
}
